(function(){
	'use strict';

	const dropdownClass = '.js-dropdown-list__link',
      dropdownList = '.dropdown-list__list';

	function init() {

		bind();
	}

	function bind() {

		$(dropdownClass).on('click.dropdown', function() {

			$(this).attr('aria-expanded',$(this).next().is(':hidden'));

			if ( $(this).hasClass('opened') ) {

				$(this).removeClass('opened').next().slideUp();
			} else {

				$(dropdownClass).removeClass('opened').next().slideUp();
				$(this).addClass('opened').next().slideDown();
			}
		});

		$(dropdownClass).on('focus', function() {

			$(dropdownClass).next().slideUp().end().removeClass('opened');
		});

		$(document).on('click.dropdown', function (ev) {
			if (!$(ev.target).is('.dropdown-list') && !$(ev.target).is('.dropdown-list ' + ' *')) {

				$(dropdownList).slideUp();
				$(dropdownClass).attr('aria-expanded','false').removeClass('opened');
			}
		});
	}


	init();


	function toggleAccordion(item) {
    if (item.hasClass('open')) {
            item.removeClass('open');
            item.attr('aria-expanded', 'false');
            item.siblings('.module-filter__facets').slideToggle(600);
        } else {
            item.addClass('open');
            item.attr('aria-expanded', 'true');
            item.siblings('.module-filter__facets').slideToggle(600);
        }
	}

	function toggleModuleFilter(e) {
		let item = $(this);
		if (e.type == 'click') {
			toggleAccordion(item);
		} else if (e.type == 'keydown') {
			if (e.keyCode == 32) {
				e.preventDefault(); 
				toggleAccordion(item);
			}
		}
	}

	function toggleModuleFilterMobile(e) {
		e.preventDefault();
		let item = $(this);
		if (item.hasClass('active')) {
			item.removeClass('active');
			item.siblings('.module-filter__wrapper-mobile').slideUp(600);
		} else {
			item.addClass('active');
			item.siblings('.module-filter__wrapper-mobile').slideToggle(600);
		}
	}

	$('.module-filter__item-title').on('click', toggleModuleFilter);
	$('.module-filter__item-title').on('keydown', toggleModuleFilter);
	$('.module-filter__title').on('click', toggleModuleFilterMobile);

}());
